
import React from 'react';
import {
  StripeProvider,
  Elements
} from 'react-stripe-elements';
import { connect } from 'react-redux';

import CharityDonateComponent from '../../components/app/Charity/CharityDonate';

import * as actions from '../../actions/charity/charity-donate';

const CharityDonate = (props) => {
  return (
    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_TEST_KEYS}>
      <Elements>
        <CharityDonateComponent {...props} />
      </Elements>
    </StripeProvider>
  );
};

export default connect(({ charity, user }) => ({ charityDonate: charity.charityDonate, user }), actions)(CharityDonate);

